import * as React from 'react';
import { Dropdown, IDropdownOption, IDropdownStyles } from '@fluentui/react/lib/Dropdown';
import { getDisplayHours } from './getDisplayHours';

const styles = require('./CalendarPrintHourPicker.scss');

export interface CalendarPrintHourPickerProps {
    label: string;
    min: number;
    max: number;
    selected: number;
    onChanged: (this: void, selected: number) => void;
    customStyles?: Partial<IDropdownStyles>;
}

/**
 * Render a drop down that shows a list of hours.
 */
export function CalendarPrintHourPicker(props: CalendarPrintHourPickerProps) {
    const dropdownCalloutStyles = {
        callout: styles.printHourDropdown,
    };

    const options = getDisplayHours(props.min, props.max);

    const onDropdownChanged = (option: IDropdownOption, index: number) =>
        props.onChanged(options[index].key as number);

    return (
        <Dropdown
            label={props.label}
            options={options}
            selectedKey={props.selected}
            onChanged={onDropdownChanged}
            styles={{ ...dropdownCalloutStyles, ...props.customStyles }}
        />
    );
}
